import React from 'react'
import PropTypes from 'prop-types'

export const Workspace = (props) => {
  return (
    <div className='workspace'>
      {props.children}
    </div>
  )
}

Workspace.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
}